export class AppEnvironment {
    public static devMode = false;
}
